import React from 'react';
import { useForm } from 'react-hook-form';
import { request } from '@/lib/fetch';
import { countries, citiesOfCountries } from './const';
import { useAsync, STATUSES } from './use-async';
import get from 'lodash/get';

export const useHowToHelp = () => {
    const [message, setMessage] = React.useState('');
    const [cities, setCities] = React.useState([]);

    const {
        register,
        handleSubmit,
        getValues,
        reset,
        formState: { isDirty },
        watch, control,
        setValue,
        errors,
        trigger,
    } = useForm();
    const watchSelectCountry = watch('info.Country', false);

    React.useEffect(() => {
        setValue('info.City', null);
        if (!watchSelectCountry) {
            setCities([]);
            return;
        }
        setCities(get(citiesOfCountries, `[${watchSelectCountry}]`, []));
    }, [watchSelectCountry]);

    const send = async () => {
        const values = getValues();
        return request('/api/donations/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(values),
        });
    };
    const { execute, status, error } = useAsync(send, false);
    React.useEffect(() => {
        if (status !== STATUSES.ERROR && status !== STATUSES.SUCCESS) {
            return;
        }
        if (status === STATUSES.ERROR) {
            setMessage('Could not send email. Please try again later.');
        }
        if (status === STATUSES.SUCCESS) {
            setMessage('Thank you for getting in touch! We will get back in touch with you soon.');
        }
        reset();
    }, [status]);

    // clear form's status when user interacts with
    React.useEffect(() => {
        if (isDirty) {
            setMessage('');
        }
    }, [isDirty]);
    return {
        register,
        handleSubmit,
        execute,
        status,
        message,
        error,
        control,
        cities,
        countries,
        errors,
        trigger,
    };
};
